import { ORGANIZATIONS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function updateOrgEmailTemplate(data) {
	const url = `/${ORGANIZATIONS_PREFIX}/updateEmailTemplates`;
	return postApi(url, data);
}
